import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

const prefixUrl = "eval/outStandingLianYou/Stat/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const columns = utils.columns(
    [
        {   
            key:'$index', 
            label: '序号',
            width: 80
        },
        {
            key: 'orgName',
            label: '所属部门',
            width: 100
        },
        {
            key:'employeeCode', 
            label: '教师工号',
            width: 100
        },
        {
            key: 'employeeName',
            label: '教师姓名',
            width: 100
        },
        {
            key: 'organization', 
            label: '是否在编',
            width: 100,
            render: (data) => {
                if(data == 2){
                    return '在编';
                } else if(data == 1){
                    return '外聘';
                } else {
                    return '未知状态';
                }
            }
        },
        {
            key: 'yearName', 
            label: '所属学年',
            width: 100
        },
        {
            key: 'resultDesc', 
            label: '备注',
            width: 100
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    if(`${keywords.sort}` != 'undefined'){
        params.push(`sort=${keywords.sort}`)
        params.push(`order=${keywords.order}`)
    }
    return fetch.post(`${prefixUrl}query?` + params.join('&'), keywords)
    .then(response => {
        if (response.code === 200) {
            return {
                data: response.payload.data,
            }
        }
    })
    .then(res => (
        Object.assign({
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        }))
    )
}

const removeByIds = (ids) => {
    return fetch.post(`${prefixUrl}deleteByIds`, ids).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const removeByQuery = (keywords) => {
    return fetch.post(`${prefixUrl}deleteByQuery`, keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    })
}

const statOutStand = (keywords = {}) => {
    return fetch.post(`${prefixUrl}statOutStand`, keywords)
    .then((response) => {
        return response;
    })
}

export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    querySearch,
    columns,
    removeByIds,
    removeByQuery,
    statOutStand
}